(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputUiSelectCountry', cpInputUiSelectCountry);

    cpInputUiSelectCountry.$inject = ['countryListSrvc'];

    function cpInputUiSelectCountry(countryListSrvc) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-ui-select-country/input-ui-select-country.html',
            scope: {
                title: "@?",
                labelClass: '@?',
                containerClass: '@',
                object: '=',
                prop: '@',
                options: '=?',
                isRequired: '=?',
                isDisabled: '=?',
                isMultiple: '=?',
                onChange: '&?'
            },
            link: function(scope, element, attrs, controller) {
                scope.getLabelClass = getLabelClass;
                scope.getContainerClass = getContainerClass;
                scope.isWithLabel = isWithLabel;

                activate();

                function activate() {
                    if (!scope.options) {
                        countryListSrvc.get()
                            .$promise.then(function(response) {
                                scope.options = response.data;
                            });
                    }
                }

                function isWithLabel() {
                    return scope.fullWidth === undefined ? true : scope.withLabel;
                }

                function getLabelClass() {
                    if (scope.labelClass) {
                        return scope.labelClass;
                    } else {
                        return isWithLabel() ? 'col-sm-2' : '';
                    }
                }

                function getContainerClass() {
                    if (scope.containerClass) {
                        return scope.containerClass;
                    } else {
                        return isWithLabel() ? 'col-sm-10' : 'col-sm-12';
                    }
                }
            }
        };
    }
})();
